/**
 * @author PoornaChandu
 */
import React, { useState, useEffect, useRef } from 'react';
import _ from 'lodash';
import {
  Button,
  Checkbox,
  DatePicker,
  Drawer,
  Form,
  Input,
  Popconfirm,
  Radio,
  Select,
  Tooltip,
  message
} from 'antd';
import {
  deleteMaintainance,
  getMaintainenceList,
  ruleList,
  saveMaintainance,
  updateMaintainance
} from '../Apicalls.js';
import { DrawerFooter } from '../../../commons/styles/layout';
import { DeleteOutlined, EditOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { constant } from '../../AMM/Utils/constants.js';
import StyledTable from "../../../commons/styles/table.js";
import { connect } from 'react-redux';
// import { getCurrentTimezone } from '../../../selectors/layout.js';
import translation from '../../../utils/translation.js';
import dayjs from 'dayjs';
import { StyledHomepage } from '../../../commons/styles/layout.js';
// import { getTranslationCache } from '../../../selectors/language.js';
// import { createStructuredSelector } from 'reselect';
const { Option } = Select;
const RuleEngineMaintainance = (props) => {
  const [data, setData] = useState([]);
  const [editObj, setEditObj] = useState({});
  const [ruleData, setRuleData] = useState({});
  const [showDrawer, setShowDrawer] = useState(false);
  const [reset, setReset] = useState(false);
  const hRef = useRef(null);
  useEffect(() => {
    getDatasourceList();
    getRuleList();
  }, []);
  const getRuleList = async () => {
    let ruleData = await ruleList();
    setRuleData(ruleData);
  };
  const getDatasourceList = async () => {
    let data = await getMaintainenceList();
    setData(data);
  };
  const _update = async () => {
    let currentEditObj = editObj;
    try {
      const values = await hRef.current.validateFields();
      const formattedValues = {
        ...values,
        StartDate: dayjs.utc(values.StartDate).format('YYYY-MM-DD HH:mm:ss'),
        EndDate: dayjs.utc(values.EndDate).format('YYYY-MM-DD HH:mm:ss'),
        Id: currentEditObj.Id
      };
      let saveResponse = await updateMaintainance(formattedValues);
      if (saveResponse && saveResponse.data && saveResponse.data.message) {
        message.success(translation(props.translationCache, saveResponse.data.message));
        onClose();
        getDatasourceList();
      }
    } catch (error) {
      console.log(error);
    }
  };
  const _create = async () => {
    try {
      const values = await hRef.current.validateFields();
      let saveResponse = await saveMaintainance(values);
      if (saveResponse && saveResponse.data && saveResponse.data.message) {
        message.success(translation(props.translationCache, saveResponse.data.message));
        onClose();
        getDatasourceList();
      }
    } catch (error) {
      console.log(error);
    }
  };
  const onClose = () => {
    setShowDrawer(false);
    setEditObj({});
    if (hRef.current) hRef.current.resetFields();
  };
  const add = () => {
    let defaultData = { LogicType: 'DateInterval', Reset: null };
    setShowDrawer(true);
    setEditObj(defaultData);
    if (hRef.current) {
      hRef.current.setFieldsValue({
        ...defaultData,
        RuleId: [],
        StartDate: '',
        EndDate: '',
        NumberOfTimes: ''
      });
    }
  };
  const _deleteById = async (Id) => {
    let deleteResponse = await deleteMaintainance(Id);
    if (deleteResponse && deleteResponse.message) {
      message.success(translation(props.translationCache, deleteResponse.message));
      getDatasourceList();
    }
  };
  const onEdit = (editObj) => {
    const clonedEditObj = _.cloneDeep(editObj);
    if (clonedEditObj.StartDate) {
      clonedEditObj.StartDate = dayjs.utc(clonedEditObj.StartDate, 'YYYY-MM-DD HH:mm:ss').local();
    }
    if (clonedEditObj.EndDate) {
      clonedEditObj.EndDate = dayjs.utc(clonedEditObj.EndDate, 'YYYY-MM-DD HH:mm:ss').local();
    }
    setEditObj(clonedEditObj);
    setShowDrawer(true);
    if (hRef.current) hRef.current.setFieldsValue(clonedEditObj);
  };
  const columns = [
    {
      title: translation(props.translationCache, 'Rule Name'),
      dataIndex: 'RuleName',
      key: 'RuleName',
      render: (text) => {
        return {
          children: <div>{text}</div>
        };
      }
    },
    {
      title: translation(props.translationCache, 'Created By'),
      dataIndex: 'CreatedbyName',
      key: 'CreatedbyName'
    },
    {
      title: translation(props.translationCache, 'Created Date'),
      dataIndex: 'CreatedDate',
      key: 'CreatedDate',
      render: (text) => {
        return {
          children: <div>{dayjs(text).format('YYYY-MM-DD HH:mm:ss')}</div>
        };
      }
    },
    {
      title: translation(props.translationCache, 'Action'),
      dataIndex: 'Action',
      key: 'Action',
      render: (text, row) => {
        return {
          children: (
            <div>
              <Tooltip title={translation(props.translationCache, 'Edit')}>
                <Button
                  type="primary"
                  className="ant-btn"

                  onClick={(e) => {
                    e.stopPropagation();
                    onEdit(row);
                  }}
                >
                  <EditOutlined />
                </Button>
              </Tooltip>
              <Popconfirm
                title={translation(props.translationCache, 'Do you want to delete?')}
                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                onConfirm={() => _deleteById(row.Id)}
                okText={translation(props.translationCache, 'Yes')}
                cancelText={translation(props.translationCache, 'No')}
              >
                <Button type="primary" className="ant-btn" >
                  <Tooltip title={translation(props.translationCache, constant.Delete)}>
                    <DeleteOutlined />
                  </Tooltip>
                </Button>
              </Popconfirm>
            </div>
          )
        };
      }
    }
  ];
  return (
    <StyledHomepage>
      <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '10px 0px' }}>
        <Button type="primary" onClick={add}>
          {translation(props.translationCache, 'Add Maintainance')}
        </Button>
      </div>
      <Drawer
        title={
          !editObj.Id
            ? translation(props.translationCache, 'Create Maintainance')
            : translation(props.translationCache, 'Update Maintainance')
        }
        open={showDrawer}
        width={600}
        onClose={onClose}
      >
        <Form
          layout="vertical"
          name={'MaintainanceForm'}
          ref={hRef}
          labelCol={{ span: 10 }}
          wrapperCol={{ span: 14 }}
          initialValues={editObj || {}}
        >
          <Form.Item
            label={translation(props.translationCache, 'Select Rule')}
            name="RuleId"
            rules={[{ required: true }]}
          >
            <Select placeholder={translation(props.translationCache, 'Select Rule')}>
              {ruleData &&
                Array.isArray(ruleData) &&
                ruleData.map((rule, index) => (
                  <Option key={index} value={rule.Id}>
                    {rule.DisplayRuleName}
                  </Option>
                ))}
            </Select>
          </Form.Item>
          <Form.Item name="LogicType" rules={[{ required: true }]}>
            <Radio.Group
              options={[
                {
                  label: translation(props.translationCache, 'Date Interval'),
                  value: 'DateInterval'
                },
                {
                  label: translation(props.translationCache, 'No of Days'),
                  value: 'NoOfDays'
                }
              ]}
              onChange={(e) => setEditObj({ ...editObj, LogicType: e.target.value })}
            />
          </Form.Item>
          {editObj && editObj['LogicType'] === 'DateInterval' ? (
            <>
              <Form.Item
                label={translation(props.translationCache, 'Start Date')}
                name="StartDate"
                rules={[{ required: true }]}
              >
                <DatePicker
                  style={{ width: 300 }}
                  format="YYYY-MM-DD HH:mm:ss"
                  placeholder={translation(props.translationCache, 'Select Start Date')}
                  showTime
                  disabledDate={(d) =>
                    !d ||
                    d.isAfter(
                      hRef.current &&
                        hRef.current !== null &&
                        hRef.current.getFieldValue() &&
                        hRef.current.getFieldValue('EndDate')
                        ? dayjs(
                          hRef.current.getFieldValue() &&
                          hRef.current.getFieldValue('EndDate')
                        ).format('YYYY-MM-DD HH:mm:ss')
                        : ''
                    ) ||
                    d.isBefore(dayjs().format('YYYY-MM-DD HH:mm:ss'))
                  }
                />
              </Form.Item>
              <Form.Item
                label={translation(props.translationCache, 'End Date')}
                name="EndDate"
                rules={[{ required: true }]}
              >
                <DatePicker
                  style={{ width: 300 }}
                  format="YYYY-MM-DD HH:mm:ss"
                  placeholder={translation(props.translationCache, 'Select End Date')}
                  showTime
                  disabledDate={(d) =>
                    !d ||
                    d.isBefore(
                      hRef.current &&
                        hRef.current !== null &&
                        hRef.current.getFieldValue() &&
                        hRef.current.getFieldValue('StartDate')
                        ? dayjs(hRef.current.getFieldValue('StartDate')).format('YYYY-MM-DD HH:mm:ss')
                        : ''
                    ) ||
                    d.isBefore(dayjs().format('YYYY-MM-DD HH:mm:ss'))
                  }
                />
              </Form.Item>
            </>
          ) : (
            <Form.Item
              label={translation(props.translationCache, 'Number Of Days')}
              name="NumberOfDays"
              rules={[{ required: true }]}
            >
              <Input placeholder={translation(props.translationCache, 'Number Of Days')} />
            </Form.Item>
          )}
          <Form.Item
            label={translation(props.translationCache, 'Number Of Times')}
            name="NumberOfTimes"
            rules={[{ required: true }]}
          >
            <Input placeholder={translation(props.translationCache, 'Number Of Times')} />
          </Form.Item>
          <Form.Item
            label={translation(props.translationCache, 'Reset')}
            name="Reset"
            valuePropName="checked"
          >
            <Checkbox
              checked={reset}
              onChange={(e) => setReset(e.target.checked)}
            />
          </Form.Item>
        </Form>
        <DrawerFooter>
          <Button type='primary' onClick={onClose} style={{ marginRight: 8 }}>
            {translation(props.translationCache, 'Cancel')}
          </Button>
          {/* <div style={{marginRight:10, display:'flex', flexDirection:'row'}}> */}
          {!editObj.Id ? (
            <Button type="primary" onClick={_create} style={{ marginRight: 20 }} >
              {translation(props.translationCache, 'Create')}
            </Button>
          ) : (
            <Button type="primary" onClick={_update} style={{ marginRight: 20 }}>
              {translation(props.translationCache, 'Update')}
            </Button>
          )}
          {/* </div> */}
        </DrawerFooter>
      </Drawer>
      <StyledTable size="small" columns={columns} dataSource={data && Array.isArray(data) ? data : []} />
    </StyledHomepage>
  );
};
const mapStateToProps = (state) => {
  return {
    currentTimeZone: state.LayoutReducer.currentTimeZone,
    translationCache: state.TranslationReducer.translationCache,
  };
};
export default connect(mapStateToProps)(RuleEngineMaintainance);
